import {
  UPDATE_PROFILE_SETTINGS_LOADING,
  UPDATE_PROFILE_SETTINGS_SUCCESS,
  UPDATE_PROFILE_SETTINGS_ERROR
} from '../actions/types';

const initialState = {
  loading: false,
  error: null,
  profileSettings: {}
};

export const profileSettings = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PROFILE_SETTINGS_LOADING:
      return {
        ...state,
        loading: true
      };
    case UPDATE_PROFILE_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        profileSettings: action.payload
      };
    case UPDATE_PROFILE_SETTINGS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};
